module.exports = __webpack_public_path__ + "static/media/instagram.c490abb2.svg";